import { h, Fragment } from 'preact'

import iconStyle from '@styles/icon.module.css'

import cookieSettingStyle from './CookieSetting/style.module.css'
import style from './style.module.css'

import CookieSettingContainer from './CookieSetting'
import LockBodyScroll from './LockBodyScroll'

import useI18NText from './hooks/useI18NText'

export default function Template({
  isApp,
  cookieSetting,
  shouldShowConsentBanner,
  setShouldShowConsentBanner,
  isOpenCookieSetting,
  setIsOpenCookieSetting,
  handleOnClickPolicyLink,
  handleOnClickCookiePolicyLink,
  handleOnClickAccept,
  handleOnOpenCookieSetting,
}) {
  const text = useI18NText('consentBanner')

  return (
    <Fragment>
      {shouldShowConsentBanner && (
        <div className={style.ConsentBanner}>
          <div className={style.cookieWrapper}>
            <div className={style.notiIcon}>
              <img
                src="https://s.isanook.com/sr/0/images/cookiepolicy.png"
                alt="kookkak"
                className={style.notiIconImg}
              />
            </div>

            <p className={style.paragraph}>
              <strong>{text.title}</strong> {text.description}
              <br />
              <a
                className={style.link}
                onClick={handleOnClickPolicyLink}
                href="https://www.sanook.com/policy/"
                target={isApp ? '_self' : '_blank'}>
                {text.policyBtn}
              </a>{' '}
              {text.separator}{' '}
              <a
                className={style.link}
                onClick={handleOnClickCookiePolicyLink}
                href="https://www.sanook.com/cookiepolicy/"
                target={isApp ? '_self' : '_blank'}>
                {text.cookiePolicyBtn}
              </a>
            </p>
            <div className={style.buttonGroup}>
              <button
                className={style.button}
                type="button"
                onClick={handleOnClickAccept}>
                {text.acceptBtn}
              </button>
              <button
                className={style.setting}
                type="button"
                onClick={handleOnOpenCookieSetting}>
                <i
                  className={`${iconStyle['sn-icon']} ${iconStyle['sn-icon--setting']}`}
                />
              </button>
            </div>
          </div>
        </div>
      )}

      {isOpenCookieSetting && (
        <CookieSettingContainer
          cookieSetting={cookieSetting}
          isOpenCookieSetting={isOpenCookieSetting}
          setIsOpenCookieSetting={setIsOpenCookieSetting}
          setShouldShowConsentBanner={setShouldShowConsentBanner}
        />
      )}
      <LockBodyScroll
        shouldLockScroll={isOpenCookieSetting}
        allowScrollElementClassLists={[
          cookieSettingStyle.modalSetting,
          cookieSettingStyle.descScroll,
        ]}
      />
    </Fragment>
  )
}
